import moment from 'moment';

export default {
  isPaidUser(state) {
    return state.is_paid;
  },
  isProfileLoading(state) {
    return state.loading;
  },
  getProfile(state) {
    return state;
  },
  getOnboarding(state) {
    return state.onboarding;
  },
  getMyRTUserDetails(state) {
    return state.my_rt_user_details;
  },
  getOrderedNotifications(state) {
    // Deep Clone Array
    const notifications = JSON.parse(JSON.stringify(state.notifications));
    notifications.forEach((n) => {
      n.created_at = moment(n.created_at).fromNow();
    });
    return notifications;
  },
  hasAdminAdminPermission(state) {
    if (state.role === 'admin') {
      return true;
    }
    else if (state.school && state.school.admin_role) {
      return state.school.admin_role === 'admin';
    }
    else {
      return false;
    }
  },
  hasAdminCoachPermission(state) {
    if (state.school && state.school.admin_role) {
      return state.school.admin_role === 'coach';
    } else {
      return false;
    }
  },
  getProviders(state) {
    return state.providers;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/account/getters.js